import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../AuthStore/AuthStore";

const ProtectedRoute = () => {
    const { username } = useAuthStore();

    // Redirect unauthenticated users to login
    return username ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
